import ApprovalSetting from './leavemanagement';
export default ApprovalSetting;